import createReducer from '../createReducer';
import {
  SET_SWELL_PERIOD_COLORS,
  SET_SWELL_PERIOD_ARROW_OPTIONS,
  OVERWRITE_CHART_CONFIG,
  SET_SWELL_PERIOD_PARTICLE_OPTIONS,
} from '../../actions/charts';

// Swell period values are encoded in the tile sets as HERTZ.
const scaleInHertz = [
  { value: 1 / 22, color: [195, 34, 40] },
  { value: 1 / 21, color: [252, 13, 27] },
  { value: 1 / 20, color: [253, 75, 30] },
  { value: 1 / 19, color: [252, 100, 35] },
  { value: 1 / 18, color: [253, 172, 42] },
  { value: 1 / 17, color: [255, 253, 56] },
  { value: 1 / 16, color: [199, 253, 54] },
  { value: 1 / 15, color: [156, 253, 50] },
  { value: 1 / 14, color: [66, 253, 47] },
  { value: 1 / 13, color: [43, 253, 87] },
  { value: 1 / 12, color: [43, 253, 157] },
  { value: 1 / 11, color: [43, 254, 205] },
  { value: 1 / 10, color: [34, 198, 253] },
  { value: 1 / 9, color: [25, 151, 252] },
  { value: 1 / 8, color: [17, 102, 239] },
  { value: 1 / 7, color: [40, 45, 250] },
  { value: 1 / 6, color: [7, 26, 201] },
];

export const initialState = {
  tileLayerOptions: {
    maxZoom: 6,
    minZoom: 1,
    renderTransparentArea: true,
  },
  gradientColoringFragmentOptions: {
    decode: {
      channel: 'r',
      min: 0.045,
      max: 0.4,
    },
    stops: scaleInHertz,
    smooth: false,
    opacity: 1.0,
  },
  particleOptions: {
    decodeAsWaves: true,
    decodeChannels: 'rg',
    decodeMin: 0,
    decodeMax: 1,
    color: [255, 255, 255, 60],
    size: 1,
    drawAsLines: true,
    speed: 0.001,
    maxAmount: 128,
    density: 4,
    refreshInterval: 800,
    fadeFactor: 0.05,
  },
  arrowLayerOptions: {
    decodeChannels: 'gb',
    decodeMin: -4,
    decodeMax: 4,
    size: 10,
    speed: 0.00122,
    maxAmount: 128,
    density: 4,
    refreshInterval: 1385,
    color: [255, 255, 255, 120],
    rttTimestep: 70,
    worldSpaceConstant: false,
    speedWeightedByVectorNorm: false,
    scaleSize: {
      decodeChannels: 'r',
      decodeMin: 0,
      decodeMax: 16,
      arrowMinSize: 5,
    },
  },
};

const handlers = {
  [SET_SWELL_PERIOD_COLORS]: (state, { colors }) => ({
    ...state,
    gradientColoringFragmentOptions: {
      ...state.gradientColoringFragmentOptions,
      stops: colors,
    },
  }),
  [SET_SWELL_PERIOD_ARROW_OPTIONS]: (state, { options }) => ({
    ...state,
    arrowLayerOptions: {
      ...state.arrowLayerOptions,
      ...options,
    },
  }),
  [SET_SWELL_PERIOD_PARTICLE_OPTIONS]: (state, { options }) => ({
    ...state,
    particleOptions: {
      ...state.particleOptions,
      ...options,
    },
  }),
  [OVERWRITE_CHART_CONFIG]: (_, { config }) => ({
    ...config.period,
  }),
};

export default createReducer(handlers, initialState);



// WEBPACK FOOTER //
// ./src/reducers/charts/period.js